import React from 'react';
import { Container, Button, Badge } from '../design-system';
import { ArrowRight, CheckCircle, Sparkles } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { trackEvent } from '../utils/analytics';

interface HeroProps {
  onContactClick: () => void;
}

export function Hero({ onContactClick }: HeroProps) {
  const { t } = useI18n();
  return (
    <section id="hero" className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-200/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      <Container maxWidth="xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center relative">
          <div className="text-center lg:text-left">
            <Badge variant="primary" className="mb-6 gap-2">
              <Sparkles className="w-3 h-3" />
              {t('hero.badge')}
            </Badge>
            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
              {t('hero.title.prefix')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
                {t('hero.title.highlight')}
              </span>
            </h1>
            <p className="text-xl text-slate-600 mb-8 max-w-2xl">
              {t('hero.subtext')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-slate-700">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>{t('hero.bullets.process')}</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>{t('hero.bullets.deliveries')}</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>{t('hero.bullets.security')}</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button size="lg" onClick={() => { trackEvent('cta_click', { location: 'hero' }); onContactClick(); }}>
                {t('hero.cta.primary')}
                <ArrowRight className="w-5 h-5" />
              </Button>
            </div>
          </div>
      
            <div className="relative">
              <img
                src="/images/bg.png"
                alt="Gruty - soluções digitais sob medida"
                className="w-full h-auto rounded-2xl"
                  width={665}
                  height={456}
                decoding="async"
                fetchPriority="high"
              />
            </div>
        </div>
      </Container>
    </section>
  );
}
